import { mapState, mapActions, mapMutations } from 'vuex'
import PageDropdown from '@/components/page-dropdown/page-dropdown.vue'
import IcStatusEnabled from '@/assets/svg/ic-status-enabled.svg?inline'
import IcStatusDisabled from '@/assets/svg/ic-status-disabled.svg?inline'
import IcStatusNotAvailable from '@/assets/svg/ic-status-not-available.svg?inline'
import formatFunctons from '@/components/mixins/format-functions'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  name: 'System',
  /**
   * formatFuncton:
   *  getFormatDate
   *  getShortId
   *  getCookedTime
   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [formatFunctons, copyTextMixin],
  components: {
    PageDropdown,
    IcStatusEnabled,
    IcStatusDisabled,
    IcStatusNotAvailable
  },
  data() {
    return {
      systemInfo: null
    }
  },
  computed: {
    ...mapState({
      orderStatuses: state => state.sharedData.orderStatuses
    }),
    shelvingCols() {
      const colCount = 3
      const colsArr = []
      const shelvingArr = []
      for (let i = 0; i < colCount; i++) {
        colsArr.push([])
      }
      for (let i = 0; i < this.systemInfo.shelving.total_cells; i++) {
        shelvingArr.push({
          cell: i + 1
        })
      }
      this.systemInfo.shelving.orders_shelving
        .filter(order => parseInt(order.cell))
        .forEach(order => {
          if (shelvingArr[+order.cell - 1]) {
            shelvingArr[+order.cell - 1] = order
          }
        })
      const limitCol = Math.ceil(shelvingArr.length / colCount)
      for (let i = 0; i < colCount; i++) {
        colsArr[i] = shelvingArr.slice(limitCol * i, limitCol * (i + 1))
      }
      return { colsArr, limitCol }
    },
    tableShelving() {
      if (this.systemInfo && this.systemInfo.shelving) {
        return this.systemInfo.shelving.orders_shelving
          .filter(order => !parseInt(order.cell) && order.cell !== 'Админ')
      }
      return []
    },
    tableAdmin() {
      if (this.systemInfo && this.systemInfo.shelving) {
        return this.systemInfo.shelving.orders_shelving
          .filter(order => order.cell === 'Админ')
      }
      return []
    }
  },
  async mounted() {
    try {
      this.setLoading(true)
      const res = await this.getSystemInfo()
      this.systemInfo = res
      this.setLoading(false)
    } catch(e) {
      this.setLoading(false)
      throw e
    }
    
  },
  methods: {
    ...mapActions({
      getSystemInfo: 'system/getSystemInfo'
    }),
    ...mapMutations({
      setLoading: 'pageLoader/SET_LOADING'
    }),
    getOnOffTxt(flag) {
      if (flag) {
        return 'On'
      }
      return 'Off'
    },
    getCookingTime(secNum) {
      const isNegative = secNum < 0

      return {
        isNegative,
        timeFormat: `${isNegative ? '-' : ''}${this.$moment.utc(Math.abs(secNum) * 1000).format('HH:mm')}`
      }
    },
    getIdHtml(id) {
      const idStr = id.toString()
      const last4Chars = idStr.substr(-4);
      const startChars = idStr.substring(0, idStr.length-4);
      if (startChars) {
        return `${startChars} <b>${last4Chars}</b>`
      }
      return `<b>${last4Chars}</b>`
    }
  }
}